module.exports = [{
      plugin: require('/Users/dhenkel001/Documents/New Ventures/SpringBox/pwc-new-ventures/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-WK8VLVF","includeInDevelopment":false},
    }]
